<template>
  <div>
    <div class="back-button">
      <span
        @click="$router.push({ name: 'AboutCircle' })"
        :style="{ color: getPrimaryColor(), cursor: 'pointer' }"
      >
        <font-awesome-icon
          class="mr-2"
          :style="{ color: getPrimaryColor() }"
          :icon="['fas', 'arrow-left']"
        />
        Back</span
      >
    </div>
    <p class="title">
      Leave {{ currentCircle.condition_type
      }}{{
        !currentCircle.condition_type.toLowerCase().includes("circle")
          ? " Circle"
          : ""
      }}
    </p>
    <div class="card">
      <p class="card-title">Deactivate</p>
      <p class="card-info">
        Your profile page, profile photo, and reported data will no longer be
        displayed on the site. We will keep this information on the site’s
        servers – so you can re-open your account in the future if you want to.
        Your username, posts, and messages will remain visible on the site.
      </p>
      <a-button
        :disabled="isDeactivated()"
        class="button"
        :style="{ background: isDeactivated() ? '#dedede' : getPrimaryColor() }"
        @click="() => openConfirmModal('deactivate')"
      >
        Deactivate
      </a-button>
    </div>
    <div class="card">
      <p class="card-title">Delete</p>
      <p class="card-info">
        All of your data will be removed from our system and will not be used
        for future research. Deleting your account will take 5 days to process.
        You will be unable to reactivate your account after the 5 day period.
      </p>
      <a-button
        class="button"
        :style="{ background: getPrimaryColor() }"
        @click="() => openConfirmModal('delete')"
      >
        Delete
      </a-button>
    </div>
    <GenericConfirmModal
      ref="confirmModal"
      confirm_text="account"
      :handleConfirm="actionText => accountAction(actionText)"
      :canUndo="true"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
import GenericConfirmModal from "../../Modals/GenericConfirmModal.vue";

const LeaveCircleRepository = RepositoryFactory.get("leaveCircle");

export default {
  name: "LeaveCircle",
  components: {
    GenericConfirmModal
  },
  mounted() {
    if (this.isDeactivated()) {
      this.$router.push(`/searchpage`).catch(err => {});
    }
  },
  methods: {
    isDeactivated() {
      const deactivated_user = JSON.parse(
        localStorage.getItem("deactivated_user")
      );
      if (
        deactivated_user &&
        deactivated_user.circle_id === this.currentCircle.id &&
        deactivated_user.user_id === this.$store.state.User.user.user.id &&
        deactivated_user.user_role === this.$store.state.User.user.user.role
      ) {
        return true;
      }
      return false;
    },
    openConfirmModal(actionText) {
      this.$refs.confirmModal._data.actionText = actionText;
      this.$refs.confirmModal.open(actionText);
    },
    accountAction(actionText) {
      if (actionText === "deactivate") {
        this.deactivate();
      } else {
        this.deleteAccount();
      }
    },
    deactivate() {
      LeaveCircleRepository.deactivate(this.currentCircle.id)
        .then(res => {
          localStorage.setItem(
            "deactivated_user",
            JSON.stringify({
              circle_id: this.currentCircle.id,
              user_role: this.$store.state.User.user.user.role,
              user_id: this.$store.state.User.user.user.id
            })
          );
          this.$refs.confirmModal.hide();
          this.$notification.success({
            message: "Successful",
            description: `Deactivated Successfully`
          });
          this.$router
            .push(`/${this.currentCircle.key_name}/select-profile`)
            .catch(err => {});
        })
        .catch(e => {
          this.$refs.confirmModal.hide();
          this.$notification.error({
            message: "Error",
            description: `Deactivation Unsuccessful`
          });
        });
    },
    deleteAccount() {
      LeaveCircleRepository.delete(this.currentCircle.id)
        .then(res => {
          localStorage.setItem(
            "deactivated_user",
            JSON.stringify({
              circle_id: this.currentCircle.id,
              user_role: this.$store.state.User.user.user.role,
              user_id: this.$store.state.User.user.user.id
            })
          );
          this.$refs.confirmModal.hide();
          this.$notification.success({
            message: "Successful",
            description: `Account deletion successfully initiated`
          });
          this.$router
            .push(`/${this.currentCircle.key_name}/select-profile`)
            .catch(err => {});
        })
        .catch(e => {
          this.$refs.confirmModal.hide();
          this.$notification.error({
            message: "Error",
            description: `Unsuccessful`
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.back-button {
  font-family: "Lato";
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 48px;
  text-align: start;
  @media only screen and (max-width: 700px) {
    margin-top: 24px;
    margin-bottom: 24px;
  }
}
.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  margin-bottom: 24px;
}

.card {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 8px rgba(60, 60, 60, 0.1);
  margin-bottom: 24px;
  padding: 24px;
  border-color: #ffffff;
}

.card-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
  margin-bottom: 16px;
}

.card-info {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #47556e;
  margin-bottom: 16px;
}

.button {
  padding: 12px 24px;
  border-radius: 6px;
  width: fit-content;
  border: none;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/home/aboutCircle/LeaveCircle.vue